// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SystemPromptResponse
 */
export interface SystemPromptResponse {
    /**
     * 
     * @type {string}
     * @memberof SystemPromptResponse
     */
    prompt: string;
    /**
     * 
     * @type {string}
     * @memberof SystemPromptResponse
     */
    submittedBy: string;
    /**
     * 
     * @type {Date}
     * @memberof SystemPromptResponse
     */
    createdAt: Date | null;
}

/**
 * Check if a given object implements the SystemPromptResponse interface.
 */
export function instanceOfSystemPromptResponse(value: object): value is SystemPromptResponse {
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('submittedBy' in value) || value['submittedBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function SystemPromptResponseFromJSON(json: any): SystemPromptResponse {
    return SystemPromptResponseFromJSONTyped(json, false);
}

export function SystemPromptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemPromptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
        'submittedBy': json['submitted_by'],
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
    };
}

export function SystemPromptResponseToJSON(json: any): SystemPromptResponse {
    return SystemPromptResponseToJSONTyped(json, false);
}

export function SystemPromptResponseToJSONTyped(value?: SystemPromptResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prompt': value['prompt'],
        'submitted_by': value['submittedBy'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

